<template>
  <el-container>
    <el-main style="padding: 0">
      <view-table
          ref="viewTable"
          :filter="filter"
          :limits="limits"
          :columns-property="columnsProperty"
          module="basic"
          url="workUnits"
          @delete="deleteHandle"
          @addOrEdit="addEditHandle"
          @select="selectHandle"
          @reset="resetHandle">
        <template slot="otherBtn">
          <el-button v-if="delAllAuth" :disabled="!selection.length" type="danger" @click="deleteRows"> 批量删除 </el-button>
        </template>
        <template slot="adSearch">
          <el-form :inline="true" :model="filter" @submit.native.prevent @keyup.enter.native="loadData(1)">
            <el-form-item label="单元编号">
              <el-input v-model.trim="filter.workUnitNo" placeholder="请输入单元编号" clearable/>
            </el-form-item>
            <el-form-item label="单元名称">
              <el-input v-model.trim="filter.workUnitName" placeholder="请输入单元名称" clearable/>
            </el-form-item>
            <el-form-item label="工作中心">
              <el-input v-model.trim="filter.workCenterName" placeholder="请输入工作中心名称" clearable/>
            </el-form-item>
          </el-form>
        </template>
      </view-table>
      <work-unit-edit ref="editPage" @save-success="loadData(1)"/>
    </el-main>
  </el-container>
</template>

<script>
  import ViewTable from "@/components/ViewTable.vue";
  import WorkUnitEdit from "@/views/information/WorkUnit/WorkUnitEdit";
  export default {
    name: "WorkUnitManagementList",
    components: { WorkUnitEdit, ViewTable},
    data() {
      return {
        limits:{
          addAuth: this.$auth(181),
          editAuth: this.$auth(183),
          delAuth: this.$auth(184),
        },
        delAllAuth: this.$auth(182),
        selection: [],
        filter: {
          workUnitNo:"",
          workUnitName:"",
          workCenterName:"",
        },
        columnsProperty:[
          {
            key:"workUnitNo",
            align:"center",
            width:120,
          },
          {
            key:"workUnitName",
            align:"left",
          },
          {
            key:"workCenterName",
            align:"left",
          },
          {
            key:"creatorName",
            align:"center",
            width:120,
          },
          {
            key:"createTime",
            align:"center",
            width:160,
          },
          {
            key: "action",
            align: "center",
            width: 140,
            slot: "action",
            fixed: "right",
          },
        ],
      };
    },

    methods: {
      // 查询
      loadData(pageNum) {
        this.$refs.viewTable.loadData(pageNum);
      },

      // 新增、编辑
      addEditHandle(row) {
        this.$refs.editPage.open(row);
      },

      selectHandle(selection) {
        this.selection = selection;
      },

      // 单个删除
      deleteHandle(row) {
        this.$http.delete("basic", "workUnits", row.pkId).then((resp) => {
          if (resp.success) {
            this.loadData(1);
            this.$message.success("删除成功");
            this.selection = [];
          }
        });
      },

      // 批量删除
      deleteRows() {
        let ids = [];
        this.selection.forEach((item) => {
          ids.push(item.pkId);
        });
        this.$confirm("确定删除吗?", "提示", { type: "warning" }).then(() => {
          this.$http.post("basic", "workUnits/deleteBatch", ids).then((resp) => {
            if (resp.success) {
              this.loadData(1);
              this.$message.success("删除成功");
              this.selection = [];
            }
          });
        });
      },

      // 重置
      resetHandle(filter) {
        this.filter = Object.assign(this.filter, filter);
      },
    },
  };
</script>
